import React from "react";
import "../../InputDropdown/Dropdownitem/Dropdownitem.scss";
const InputMultiselectItem = ({ text, OnSelect, SelectedData }) => {

    return (
        <div className="item"    >
            <input
                checked={SelectedData?.includes(text)}
                name={text}
                onChange={(e) => { OnSelect(e) }}
                type="checkbox" />
            <label>{text}</label>
        </div>
    );
};

export default InputMultiselectItem;
